import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import RightSidebar from './RightSidebar';

const WebUIChatInterface = () => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(true);
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);
  
  // Initialize with welcome message matching Open WebUI exactly
  useEffect(() => {
    setMessages([
      {
        id: 1,
        role: 'assistant',
        content: 'Hello! How can I assist you today?',
        timestamp: new Date().toLocaleTimeString()
      },
      {
        id: 2,
        role: 'assistant', 
        content: `Hello! How can I help you today? Perhaps you'd like me to list the files in the current directory?

<tool_call>
{"name": "shell", "arguments": {"command": ["ls", "-la"]}}
</tool_call>`,
        timestamp: new Date().toLocaleTimeString()
      }
    ]);
  }, []);

  // Handle send message
  const handleSend = () => {
    if (!message.trim()) return;
    
    const newMessage = {
      id: Date.now(),
      role: 'user',
      content: message,
      timestamp: new Date().toLocaleTimeString()
    };
    
    setMessages(prev => [...prev, newMessage]);
    setMessage('');
  };


  return (
    <div className="w-full h-full overflow-auto">
      <div
        className="flex h-screen"
        style={{
          paddingTop: "calc(var(--navbar-height) + 0rem)",
          backgroundColor: 'var(--bg-primary)',
          color: 'var(--text-primary)'
        }}
      >
      <Sidebar isOpen={leftSidebarOpen} onToggle={() => setLeftSidebarOpen(!leftSidebarOpen)} />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col">
        <ChatHeader 
          rightSidebarOpen={rightSidebarOpen} 
          onRightSidebarToggle={() => setRightSidebarOpen(!rightSidebarOpen)} 
        />

        <ChatMessages messages={messages} />

        <ChatInput 
          message={message} 
          setMessage={setMessage} 
          onSend={handleSend} 
        />
      </div>

      <RightSidebar 
        isOpen={rightSidebarOpen} 
        onClose={() => setRightSidebarOpen(false)} 
      />
    </div>
    </div>
  );
};

export default WebUIChatInterface;